import { render, staticRenderFns } from "./CalendarPeriodDetail.vue?vue&type=template&id=29edc070&scoped=true"
import script from "./CalendarPeriodDetail.vue?vue&type=script&lang=js"
export * from "./CalendarPeriodDetail.vue?vue&type=script&lang=js"
import style0 from "./CalendarPeriodDetail.vue?vue&type=style&index=0&id=29edc070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29edc070",
  null
  
)

export default component.exports